'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = plansSaga;

var _webUtils = require('@vezeeta/web-utils');

var _effects = require('redux-saga/effects');

var _plans = require('../actions/plans');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(sagaSubscribePlan),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sagafetchPlans),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(plansSaga);

function sagaSubscribePlan(payload) {
  var authToken, accountKey, header, body, api, response;
  return _regenerator2.default.wrap(function sagaSubscribePlan$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          /**
           * {
           *  planKey,
           *  branchKey,
           *  entityKey,
           *  roomKey,
           * }
           */
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          header = [{
            key: 'Authorization',
            value: 'bearer ' + authToken
          }, {
            key: 'AccountKey',
            value: '' + accountKey
          }];
          body = {
            PlanKey: '' + payload.planKey,
            BranchKey: '' + payload.branchKey,
            EntityKey: '' + payload.entityKey
          };


          if (payload && payload.roomKey) {
            body = _extends({}, body, { RoomKey: '' + payload.roomKey });
          }

          if (payload && payload.providerType) {
            body = _extends({}, body, { ProviderType: '' + payload.providerType });
          }

          api = new _webUtils.API();
          _context.next = 9;
          return api.post(_webUtils.Urls.plans.subscribePlan, body, header);

        case 9:
          response = _context.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context.next = 15;
            break;
          }

          _context.next = 13;
          return (0, _effects.put)((0, _plans.subscribePlansSuccess)(_extends({}, response.data, payload.payload)));

        case 13:
          _context.next = 17;
          break;

        case 15:
          _context.next = 17;
          return (0, _effects.put)((0, _plans.subscribePlansFail)(_extends({}, payload.payload)));

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function sagafetchPlans(payload) {
  var api, authToken, accountKey, header, specKeys, response;
  return _regenerator2.default.wrap(function sagafetchPlans$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          /**
           * {
           *  languageId,
           *  paymentType,
           *  countryId,
           *  areaKey,
           *  specilityKeys,
           * }
           */

          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'LanguageId',
            value: '' + payload.languageId
          }, {
            key: 'PaymentType',
            value: '' + payload.paymentType
          }, {
            key: 'CountryId',
            value: '' + payload.countryId
          }, {
            key: 'AccountKey',
            value: '' + accountKey
          }, {
            key: 'branchKey',
            value: '' + payload.branchKey
          }];
          specKeys = '';

          if (payload.isSingle) {
            if (payload && payload.specilityKeys && payload.specilityKeys.length) {
              payload.specilityKeys.forEach(function (key) {
                if (!specKeys) {
                  specKeys = '&specilityKey=' + key;
                } else {
                  specKeys = specKeys + '&specilityKey=' + key;
                }
              });
            }
          } else if (payload && payload.specilityKeys && payload.specilityKeys.length) {
            payload.specilityKeys.forEach(function (key) {
              if (!specKeys) {
                specKeys = '&specilityKeys=' + key;
              } else {
                specKeys = specKeys + '&specilityKeys=' + key;
              }
            });
          }

          response = void 0;

          if (!payload.isSingle) {
            _context2.next = 13;
            break;
          }

          _context2.next = 10;
          return api.get(_webUtils.Urls.plans.getPlansSingleDr + '?areaKey=' + payload.areaKey + '&paymentType=' + payload.paymentType + specKeys, header);

        case 10:
          response = _context2.sent;
          _context2.next = 16;
          break;

        case 13:
          _context2.next = 15;
          return api.get(_webUtils.Urls.plans.getPlans + '?areaKey=' + payload.areaKey + '&paymentType=' + payload.paymentType + specKeys, header);

        case 15:
          response = _context2.sent;

        case 16:
          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 21;
            break;
          }

          _context2.next = 19;
          return (0, _effects.put)((0, _plans.fetchPlansSuccess)(_extends({}, response.data, payload.payload)));

        case 19:
          _context2.next = 23;
          break;

        case 21:
          _context2.next = 23;
          return (0, _effects.put)((0, _plans.fetchPlansFail)(_extends({}, payload.payload)));

        case 23:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function plansSaga() {
  return _regenerator2.default.wrap(function plansSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_plans.PLANS.SUBSCRIBE.LOAD, sagaSubscribePlan);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_plans.PLANS.GET_PLANS.LOAD, sagafetchPlans);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
module.exports = exports['default'];